import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  certifications: [
    {
      id: '1',
      name: "Microsoft SC-200: Security Operations Analyst Associate",
      issuer: "Microsoft",
      date: "2025",
      status: "Active",
      credentialId: "SC-200-2025-567890",
      verificationUrl: "https://www.credly.com/badges/your-sc200-badge",
      badgeUrl: "https://images.credly.com/size/340x340/images/c34a6df4-aa89-4b44-85de-847e5b4b2df4/microsoft-certified-security-operations-analyst-associate.png",
      description: "Validates skills to mitigate threats using Microsoft Azure Sentinel, Azure Defender, and Microsoft 365 Defender.",
      skills: ["Microsoft Sentinel", "Azure Defender", "Threat Detection", "Incident Response"],
      icon: "Award"
    },
    {
      id: '2',
      name: "ISC2 Certified in Cybersecurity (CC)",
      issuer: "ISC2",
      date: "2023",
      status: "Active",
      credentialId: "CC-2023-445566",
      verificationUrl: "https://www.credly.com/badges/your-isc2-cc-badge",
      badgeUrl: "https://images.credly.com/size/340x340/images/2030e43f-8003-4d4b-9630-847add403c87/image.png",
      description: "Foundational cybersecurity certification covering security principles, business continuity, access controls, and network security.",
      skills: ["Security Principles", "Risk Management", "Access Controls", "Network Security"],
      icon: "Shield"
    },
    {
      id: '3',
      name: "SecOps Certified Network Security Practitioner (CNSP)",
      issuer: "SecOps",
      date: "2024",
      status: "Active",
      credentialId: "CNSP-2024-789123",
      verificationUrl: "https://verify.secops-institute.com/certificate/CNSP-2024-789123",
      badgeUrl: "https://images.credly.com/size/340x340/images/network-security-badge.png",
      description: "Validates practical network security skills including intrusion detection, firewall configuration, and network threat analysis.",
      skills: ["Network Security", "Intrusion Detection", "Firewall Management", "Threat Analysis"],
      icon: "Shield"
    },
    {
      id: '4',
      name: "SecOps Certified AppSec Practitioner (CAP)",
      issuer: "SecOps",
      date: "2024",
      status: "Active",
      credentialId: "CAP-2024-456789",
      verificationUrl: "https://verify.secops-institute.com/certificate/CAP-2024-456789",
      badgeUrl: "https://images.credly.com/size/340x340/images/61c9a9d9-7d72-4d95-9c16-b11e9e5b5b13/CAP-Logo.png",
      description: "Validates expertise in application security testing, secure code review, and vulnerability assessment.",
      skills: ["Application Security", "Code Review", "Vulnerability Assessment", "OWASP"],
      icon: "Bug"
    },
    {
      id: '5',
      name: "ISO/IEC 27001:2022 Information Security Associate",
      issuer: "SkillFront",
      date: "2025",
      status: "Active",
      credentialId: "ISO27001-SF-2025-001",
      verificationUrl: "https://www.skillfront.com/verify/ISO27001-SF-2025-001",
      badgeUrl: "https://images.credly.com/size/340x340/images/945dfaef-18e9-4bb8-8f4b-04e88f7e6c8e/image.png",
      description: "Validates knowledge of ISO 27001 information security management system requirements and implementation best practices.",
      skills: ["ISO 27001", "ISMS", "Risk Assessment", "Compliance"],
      icon: "Certificate"
    },
    {
      id: '6',
      name: "Google Cybersecurity Professional Certificate",
      issuer: "Google",
      date: "2023",
      status: "Active",
      credentialId: "GOOGLE-CYBER-2023-123456",
      verificationUrl: "https://www.credly.com/badges/your-google-cyber-badge",
      badgeUrl: "https://images.credly.com/size/340x340/images/0bf0f2da-a15c-4c56-b431-6d8d73bd0bf9/image.png",
      description: "Comprehensive cybersecurity training covering security frameworks, incident response, and hands-on tools.",
      skills: ["Security Frameworks", "Incident Response", "Linux", "SQL", "SIEM Tools"],
      icon: "Award"
    },
    {
      id: '7',
      name: "Google IT Support Certificate",
      issuer: "Google",
      date: "2025",
      status: "Active",
      credentialId: "GOOGLE-IT-2025-789012",
      verificationUrl: "https://www.credly.com/badges/your-google-it-badge",
      badgeUrl: "https://images.credly.com/size/340x340/images/87d73ac1-b2ad-4935-9026-df1a3c7f8b80/Professional_Certificate_-_IT_Support.png",
      description: "Validates foundational IT support skills including troubleshooting, customer service, and system administration.",
      skills: ["IT Support", "Troubleshooting", "Windows", "Network Administration"],
      icon: "Award"
    },
    {
      id: '8',
      name: "Cisco Network Defense, Ethical Hacking & Linux Fundamentals",
      issuer: "Cisco",
      date: "2023",
      status: "Active",
      credentialId: "CISCO-SEC-2023-345678",
      verificationUrl: "https://www.netacad.com/verify/CISCO-SEC-2023-345678",
      badgeUrl: "https://images.credly.com/size/340x340/images/53ae9edd-691c-411e-9a79-19c1fdf37b2b/Intro_to_Cybersecurity.png",
      description: "Comprehensive training in network defense strategies, ethical hacking methodologies, and Linux system administration.",
      skills: ["Network Defense", "Ethical Hacking", "Linux", "Penetration Testing"],
      icon: "Shield"
    }
  ]
};

const certificationsSlice = createSlice({
  name: 'certifications',
  initialState,
  reducers: {
    addCertification: (state, action) => {
      const newCertification = {
        ...action.payload,
        id: Date.now().toString()
      };
      state.certifications.push(newCertification);
    },
    updateCertification: (state, action) => {
      const { id, ...updates } = action.payload;
      const certIndex = state.certifications.findIndex(cert => cert.id === id);
      if (certIndex !== -1) {
        state.certifications[certIndex] = { ...state.certifications[certIndex], ...updates };
      }
    },
    deleteCertification: (state, action) => {
      state.certifications = state.certifications.filter(cert => cert.id !== action.payload);
    },
    setCertifications: (state, action) => {
      state.certifications = action.payload;
    }
  }
});

export const { addCertification, updateCertification, deleteCertification, setCertifications } = certificationsSlice.actions;
export default certificationsSlice.reducer; 